import { useState, useEffect } from 'react'

import dynamic from 'next/dynamic'

import type { Props as FixedBottomAdProps } from './fixedBottomAdBlock'

const DynamicFixedBottomAdBlock = dynamic(
  () => import('./fixedBottomAdBlock').then((mod) => mod.FixedBottomAdBlock),
  {
    ssr: false,
  },
)

const FixedBottomAdBlock = (props: FixedBottomAdProps) => {
  const [delayDisplay, setDelayDisplay] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setDelayDisplay(true)
    }, 500)
  }, [])
  if (!delayDisplay) return null
  return <DynamicFixedBottomAdBlock {...props} />
}

export type Props = FixedBottomAdProps
export { FixedBottomAdBlock }
